var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlms5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.978,
    height: 101.357,
    viewBox: "0 0 97.978 101.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.398,
    height: 3.398,
    rx: 1,
    transform: "translate(52.096 75.879)",
    fill: "#666"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.6,59.435H84.775V7.068A5.083,5.083,0,0,0,79.707,2h-47.3a5.083,5.083,0,0,0-5.068,5.068v6.757H3.689A1.689,1.689,0,0,0,2,15.514V59.435a1.689,1.689,0,0,0,1.689,1.689h23.65V83.085a5.083,5.083,0,0,0,5.068,5.068H49.3v15.2h3.379v-15.2H79.707a5.083,5.083,0,0,0,5.068-5.068V72.95a1.689,1.689,0,0,0-1.689-1.689H74.639a1.689,1.689,0,0,1-1.689-1.689V64.5a1.689,1.689,0,0,1,1.689-1.689H96.6V84.082l-7.956,7.94a1.745,1.745,0,0,0-.49,1.2v10.136h3.379V93.914l7.956-7.94a1.745,1.745,0,0,0,.49-1.2V62.814A3.389,3.389,0,0,0,96.6,59.435ZM5.379,57.746V17.2H66.193V57.746ZM34.1,69.571H69.571a5.068,5.068,0,0,0,.3,1.689H30.718V61.125h1.689v6.757A1.689,1.689,0,0,0,34.1,69.571Zm47.3,5.068v8.446a1.689,1.689,0,0,1-1.689,1.689h-47.3a1.689,1.689,0,0,1-1.689-1.689V74.639Zm-5.068-15.2H74.639A5.083,5.083,0,0,0,69.571,64.5v1.689H35.786V61.125h32.1a1.689,1.689,0,0,0,1.689-1.689V15.514a1.689,1.689,0,0,0-1.689-1.689h-32.1V10.446H76.328Zm5.068,0H79.707V8.757a1.689,1.689,0,0,0-1.689-1.689H34.1a1.689,1.689,0,0,0-1.689,1.689v5.068H30.718V7.068a1.689,1.689,0,0,1,1.689-1.689h47.3A1.689,1.689,0,0,1,81.4,7.068Z",
    transform: "translate(-2 -2)",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.746,12H40.475a8.436,8.436,0,0,0-6.757,3.429A8.436,8.436,0,0,0,26.961,12H6.689A1.689,1.689,0,0,0,5,13.689V47.475a1.689,1.689,0,0,0,1.689,1.689H60.746a1.689,1.689,0,0,0,1.689-1.689V13.689A1.689,1.689,0,0,0,60.746,12ZM32.028,45.786H8.379V15.379H26.961a5.083,5.083,0,0,1,5.068,5.068Zm27.028,0H35.407V20.446a5.083,5.083,0,0,1,5.068-5.068H59.057Z",
    transform: "translate(0.068 4.893)",
    fill: "#666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25,16H41.893v3.379H25Z",
    transform: "translate(13.853 7.65)",
    fill: "#666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25,20H41.893v3.379H25Z",
    transform: "translate(13.853 10.407)",
    fill: "#666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25,24H41.893v3.379H25Z",
    transform: "translate(13.853 13.164)",
    fill: "#666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25,28H41.893v3.379H25Z",
    transform: "translate(13.853 15.921)",
    fill: "#666"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9,16H25.893v3.379H9Z",
    transform: "translate(2.825 7.65)",
    fill: "#666"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9,20H25.893v3.379H9Z",
    transform: "translate(2.825 10.407)",
    fill: "#666"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9,24H25.893v3.379H9Z",
    transform: "translate(2.825 13.164)",
    fill: "#666"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9,28H25.893v3.379H9Z",
    transform: "translate(2.825 15.921)",
    fill: "#666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlms5);
export default __webpack_public_path__ + "static/media/plms5.d257ce7771673d378c8152820e7daddb.svg";
export { ForwardRef as ReactComponent };